import { apiFetch } from './client';

export type DashboardStatus = 'todo' | 'in_progress' | 'done' | 'blocked';

export interface DashboardMetrics {
  totalMilestones: number;
  completedMilestones: number;
  overallProgressPct: number;
  activeInitiatives: number;
  releasesThisQuarter: number;
}

export interface CategorySummary {
  category: string;
  total: number;
  todo: number;
  inProgress: number;
  done: number;
  blocked: number;
}

export interface Milestone {
  id: string;
  title: string;
  description: string | undefined;
  category: string;
  status: DashboardStatus;
  completionPct: number;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface RoadmapItem {
  id: string;
  title: string;
  description: string | undefined;
  quarter: number;
  year: number;
  status: DashboardStatus;
  sortOrder: number;
}

export interface ReleaseInfo {
  id: number;
  tagName: string;
  name: string;
  body: string;
  htmlUrl: string;
  publishedAt: string;
  prerelease: boolean;
  draft: boolean;
  author: string;
}

export interface RepoReleaseSummary {
  owner: string;
  repo: string;
  releases: ReleaseInfo[];
}

export interface DashboardTrendPoint {
  month: string;
  label: string;
  milestonesCompleted: number;
  cumulativeCompleted: number;
  releases: number;
}

export interface StatusDistribution {
  todo: number;
  inProgress: number;
  done: number;
  blocked: number;
  total: number;
}

export interface DashboardTrends {
  months: number;
  points: DashboardTrendPoint[];
  statusDistribution: StatusDistribution;
}

export interface DashboardSummary {
  metrics: DashboardMetrics;
  categorySummaries: CategorySummary[];
  topMilestones: Milestone[];
  currentRoadmap: RoadmapItem[];
  repoReleases: RepoReleaseSummary[];
  trends: DashboardTrends;
}

export type TimelineEventType =
  | 'milestone_completed'
  | 'release'
  | 'roadmap_change';

export interface TimelineEvent {
  date: string;
  type: TimelineEventType;
  title: string;
  description: string;
  metadata: Record<string, unknown>;
}

export interface TimelineResponse {
  timeline: TimelineEvent[];
}

export const getDashboardSummary = async (): Promise<DashboardSummary> => {
  return apiFetch<DashboardSummary>('/dashboard/summary');
};

export const getDashboardTimeline = async (
  months = 6,
): Promise<TimelineEvent[]> => {
  const response = await apiFetch<TimelineResponse>(
    `/dashboard/timeline?months=${months}`,
  );
  return response.timeline;
};
